import React from 'react';
import { NotificationProvider } from './contexts/NotificationContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import Header from './components/Header';
import BottomNavigation from './components/BottomNavigation';
import MainContent from './components/MainContent';
import './App.css';

function App() {
  return (
    <SubscriptionProvider>
      <NotificationProvider>
        <div className="app-container">
          <Header />
          <MainContent />
          <BottomNavigation />
        </div>
      </NotificationProvider>
    </SubscriptionProvider>
  );
}

export default App;
